import { render, staticRenderFns } from "./Grooming.vue?vue&type=template&id=6a144895"
var script = {}
import style0 from "./Grooming.vue?vue&type=style&index=0&id=6a144895&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports